<template>
  <vs-popup
    id="PopupHowToWrite"
    title="에너지검토서 작성방법"
    :active.sync="showPopup"
  >
    <div class="p-2">
      <table>
        <colgroup>
          <col width="240"/>
          <col width="747"/>
          <col width="120"/>
        </colgroup>
        <tr>
          <th>항목</th>
          <th>작성방법</th>
          <th>비고</th>
        </tr>
        <tr v-for="item in list" :key="item.항목">
          <td style="font-weight: 500;">{{ item.항목 }}</td>
          <td class="whitespace-pre">{{ item.작성방법 }}</td>
          <td>{{ item.비고 }}</td>
        </tr>
      </table>
    </div>
  </vs-popup>
</template>

<script>
import RadioGroup from "@/components/radio/RadioGroup.vue";

export default {
  name: 'PopupHowToWrite',
  components: {RadioGroup},
  props: {
    value: Boolean,
  },
  computed: {
    showPopup: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      }
    },
  },
  data() {
    return {
      list: [
        {
          '항목': '(1) 에너지구분',
          '작성방법': '사용에너지원을 기입한다(전력, LNG, 스팀 등)'
        },
        {
          '항목': '(2) No',
          '작성방법': '순차적으로 번호가 자동 기입된다'
        },
        {
          '항목': '(3) 공정명',
          '작성방법': '공정명을 기입한다(필요 시 에너지Map을 사용할 수 있다)'
        },
        {
          '항목': '(4) 설비명',
          '작성방법': '에너지를 사용하는 설비명을 기입한다'
        },
        {
          '항목': '(5) 에너지 사용',
          '작성방법': '(가) 에너지 단위를 기입(전기 : kWh, LNG : Nm³, 스팀 : Ton 등)\n' +
            '(나) 용량 : 설비별 용량을 기입\n' +
            '       (여러장비가 Set로 가동시에는 용량을 합산하여 기입)\n' +
            '(다) 가동시간 : 연간 설비 가동시간을 기입\n' +
            '       (계측기가 없는 경우 예상시간 기입)\n' +
            '(라) 사용량(연간) : \n' +
            '       (1) 측정장비가 없는 경우 : 용량 x 연간 가동시간\n' +
            '       (2) 측정장비가 있는 경우 : 측정값을 기록한다\n' +
            '(마) 환산량(Toe/년) : 각 에너지별 연간 사용량을 기입\n' +
            '      * 에너지별 환산식(2022. 11. 21 개정)\n' +
            '       (1) 전기 = 사용량(kWh/년) x 0.229 / 1000\n' +
            '       (2) LNG = 사용량(Nm³/년) x 1.019 / 1000\n' +
            '       (3) 스팀 = 사용량(Ton/년) x 0.0539'
        },
        {
          '항목': '(6) 평가항목',
          '작성방법': '항목별로 선택하여 평가한다\n' +
            '(가) 사용량\n' +
            '       3점 : 1,000 Toe 이상\n' +
            '       2점 : 200 Toe 이상 ~ 1,000 Toe 미만\n' +
            '       1점 : 200 Toe 미만\n' +
            '(나) 개선 가능성\n' +
            '       3점 : 30% 이상\n' +
            '       2점 : 10% 이상 ~ 30% 미만\n' +
            '       1점 : 10% 미만\n' +
            '(다) 시급성(법규적용, 자원고갈 등 기타 시급성)\n' +
            '       3점 : 1년 미만\n' +
            '       2점 : 1년 이상 ~ 3년 미만\n' +
            '       1점 : 3년 이상'
        },
        {
          '항목': '(7) 평가점수',
          '작성방법': '사용량 X 개선가능성 X 시급성 점수'
        },
        {
          '항목': '(8) 중요 에너지등록부',
          '작성방법': '(가) 평가점수 18점 이상 (M) 중요에너지등록부에 등록하여 관리\n' +
            '(나) 사용량 점수가 3점인 경우 부서장의 판단하에 중요에너지 등록부에 등록하여 개선할 수 있음'
        },
        {
          '항목': '(9) 비고',
          '작성방법': '세부내용 또는 특이사항을 기입한다'
        },
      ]
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
#PopupHowToWrite::v-deep {
  .vs-popup {
    width: 1167px;
    max-width: 95%;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border-top:1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;

  thead {  z-index: 0 !important; }
  th {
    background: #f9f9f9;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;

    border-right: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    padding: 16px 0;
    text-align: center;
  }
  td {
    background: #fff !important;
    border-right: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    padding: 6px;
  }
}
</style>
